import { render } from "./PaymentPlatform.vue?vue&type=template&id=0c5e1a6d"
import script from "./PaymentPlatform.vue?vue&type=script&lang=js"
export * from "./PaymentPlatform.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__